import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, NgZone, } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { allowedLogoFiles, datePickerMinDate, human_anatomy_points, human_anatomy_paths } from '../../shared/constants';
import { catchError, tap } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import Swal from 'sweetalert2';
import { slideInAnimation } from '../../animations/route-animation';
import { addMonths } from 'date-fns';
import { NavbarComponent } from '../../navbar/navbar.component';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import SignaturePad from 'signature_pad';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';

@Component({
	selector: 'app-followup-fct',
	templateUrl: './followup-fct.component.html',
	styleUrl: './followup-fct.component.scss',
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		]),
		slideInAnimation
	]
})
export class FollowupFCTComponent implements OnInit, OnDestroy {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	followId: any = null;
	fctId: any = null;
	followUpDetails: any = null;
	caseDetails: any = null;
	pagetitle: string = "FCT Form";
	activeTab: any = 0;
	minDate = datePickerMinDate;
	formSubmitted = false;
	doctorList: any[] = [];
	customError: any = {};
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	moduleForm: FormGroup = this.formBuilder.group({
		candidate_photo: [null],
		candidate_signature: [null],
		examining_doctor_id: [null],
		medical_profile: [null],
		location_of_test: [null],
		is_physical_examination_done: [false],
		is_medical_history_taken: [false],
		is_blood_investigation_done: [false],
		is_scans_done: [false],
		examiner_notes: [null],
		fitness_status: [null],
		fitness_date: [null],
		fitness_valid_date: [null],
		physical_examination_done: [false],
		any_restrictions: [false],
		is_x_ray_report_attached: [false],
		is_ecg_attached: [false],
		is_sonography_attached: [false],
		is_lab_reports_attached: [false],
		is_spirometry_reports_attached: [false],
		is_medications_prescribed: [false],
		is_allergies_noted: [false],

		back_flexion: [null],
		back_extension: [null],
		back_lateral_flexion_left: [null],
		back_lateral_flexion_right: [null],

		neck_flexion: [null],
		neck_extension: [null],
		neck_extension_lateral_flexion_left: [null],
		neck_lateral_flexion_right: [null],

		shoulder_left_flexion: [null],
		shoulder_left_extension: [null],
		shoulder_right_flexion: [null],
		shoulder_right_extension: [null],
		shoulder_left_abduction: [null],
		shoulder_left_adduction: [null],
		shoulder_right_abduction: [null],
		shoulder_right_adduction: [null],

		elbow_left_flexion: [null],
		elbow_left_extension: [null],
		elbow_right_flexion: [null],
		elbow_right_extension: [null],

		knee_left_flexion: [null],
		knee_right_flexion: [null],

		ankle_left_inversion: [null],
		ankle_left_eversion: [null],
		ankle_right_inversion: [null],
		ankle_right_eversion: [null],
		ankle_left_plantar: [null],
		ankle_left_dorsal: [null],
		ankle_right_plantar: [null],
		ankle_right_dorsal: [null],

		wrist_left_flexion: [null],
		wrist_right_flexion: [null],
		wrist_left_extension: [null],
		wrist_right_extension: [null],

		wrist_left_radial_extension: [null],
		wrist_right_radial_extension: [null],
		wrist_left_ulnar_extension: [null],
		wrist_right_ulnar_extension: [null],
		wrist_left_pronation: [null],
		wrist_right_pronation: [null],
		wrist_left_supination: [null],
		wrist_right_supination: [null],

		thumb_mcp_flexion: [null], index_mcp_flexion: [null], middle_mcp_flexion: [null], ring_mcp_flexion: [null], little_mcp_flexion: [null],
		thumb_pip_flexion: [null], index_pip_flexion: [null], middle_pip_flexion: [null], ring_pip_flexion: [null], little_pip_flexion: [null],
		thumb_dip_flexion: [null], index_dip_flexion: [null], middle_dip_flexion: [null], ring_dip_flexion: [null], little_dip_flexion: [null],
		thumb_abduction: [null], index_abduction: [null], middle_abduction: [null], ring_abduction: [null], little_abduction: [null],

		thumb_opposition: [true], index_opposition: [true], middle_opposition: [true], ring_opposition: [true], little_opposition: [true],

		mouth_opening: [null],
		mouth_opening_unit: ['mm']
	});

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent, private sanitizer: DomSanitizer) {
		this.apiService.doctorData$.subscribe((doctors: any) => {
			if (doctors) {
				this.doctorList = this.navbar.filterDoctors();
			}
		});
	}
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["caseId"];
			this.followId = routeParams["followId"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/" + this.followId, name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/followup-fct/" + this.uId + "/" + this.followId, name: this.pagetitle });
			this.getCaseDetails();
			this.getFollowupDetails();
			this.getFCTDetails();
			this.getReportPdf();
		});
	}

	ngOnDestroy(): void {
		try {
			/* Revoke memory on component destroy */
			this.revokeExistingUrl();
		} catch (error) {
		}
	}

	get f() { return this.moduleForm.controls; }

	isFieldInvalid(field: string) {
		if (this.f[field].invalid) {
			return true;
		}
		if (this.f[field].disabled && this.f[field].hasValidator(Validators.required) && !this.f[field].value) {
			return true;
		}
		return false;
	}

	showError(field: string) {
		if (this.isFieldInvalid(field) && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	loadingCaseDetails = false;
	getCaseDetails() {
		this.loadingCaseDetails = true;
		this.apiService.getUpdateCaseDetails({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.loadingCaseDetails = false;
				this.caseDetails = data;
			}, error: (error) => {
				this.loadingCaseDetails = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	loadingFollowupDetails = false;
	getFollowupDetails() {
		this.loadingFollowupDetails = true;
		this.apiService.getFollowupDetails(this.followId).subscribe({
			next: (data: any) => {
				this.loadingFollowupDetails = false;
				this.followUpDetails = data.data;
			}, error: (error) => {
				this.loadingFollowupDetails = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	fctDetails: any = null;
	loadingFCTDetails = false;
	getFCTDetails() {
		this.loadingFCTDetails = true;
		this.apiService.getFCT(atob(this.followId)).subscribe({
			next: (data: any) => {
				this.loadingFCTDetails = false;
				this.fctDetails = data.data;
				this.fctId = this.fctDetails.id;
				this.f.candidate_photo.setValue(this.fctDetails.candidate_photo);
				this.f.candidate_signature.setValue(this.fctDetails.candidate_signature);
				this.f.examining_doctor_id.setValue(this.fctDetails.examining_doctor);
				this.f.medical_profile.setValue(this.fctDetails.medical_profile);
				this.f.location_of_test.setValue(this.fctDetails.location_of_test);
				this.f.is_physical_examination_done.setValue(this.fctDetails.is_physical_examination_done);
				this.f.is_medical_history_taken.setValue(this.fctDetails.is_medical_history_taken);
				this.f.is_blood_investigation_done.setValue(this.fctDetails.is_blood_investigation_done);
				this.f.is_scans_done.setValue(this.fctDetails.is_scans_done);
				this.f.examiner_notes.setValue(this.fctDetails.examiner_notes);
				this.f.fitness_status.setValue(this.fctDetails.fitness_status);
				this.f.fitness_date.setValue(this.apiService.getDateFromDateStringYMD(this.fctDetails.fitness_date));
				this.f.fitness_valid_date.setValue(this.apiService.getDateFromDateStringYMD(this.fctDetails.fitness_valid_date));
				this.f.physical_examination_done.setValue(this.fctDetails.physical_examination_done);
				this.f.any_restrictions.setValue(this.fctDetails.any_restrictions);
				this.f.is_x_ray_report_attached.setValue(this.fctDetails.is_x_ray_report_attached);
				this.f.is_ecg_attached.setValue(this.fctDetails.is_ecg_attached);
				this.f.is_sonography_attached.setValue(this.fctDetails.is_sonography_attached);
				this.f.is_lab_reports_attached.setValue(this.fctDetails.is_lab_reports_attached);
				this.f.is_spirometry_reports_attached.setValue(this.fctDetails.is_spirometry_reports_attached);
				this.f.is_medications_prescribed.setValue(this.fctDetails.is_medications_prescribed);
				this.f.is_allergies_noted.setValue(this.fctDetails.is_allergies_noted);
				this.f.back_flexion.setValue(this.fctDetails.back_flexion);
				this.f.back_extension.setValue(this.fctDetails.back_extension);
				this.f.back_lateral_flexion_left.setValue(this.fctDetails.back_lateral_flexion_left);
				this.f.back_lateral_flexion_right.setValue(this.fctDetails.back_lateral_flexion_right);
				this.f.neck_flexion.setValue(this.fctDetails.neck_flexion);
				this.f.neck_extension.setValue(this.fctDetails.neck_extension);
				this.f.neck_extension_lateral_flexion_left.setValue(this.fctDetails.neck_extension_lateral_flexion_left);
				this.f.neck_lateral_flexion_right.setValue(this.fctDetails.neck_lateral_flexion_right);
				this.f.shoulder_left_flexion.setValue(this.fctDetails.shoulder_left_flexion);
				this.f.shoulder_left_extension.setValue(this.fctDetails.shoulder_left_extension);
				this.f.shoulder_right_flexion.setValue(this.fctDetails.shoulder_right_flexion);
				this.f.shoulder_right_extension.setValue(this.fctDetails.shoulder_right_extension);
				this.f.shoulder_left_abduction.setValue(this.fctDetails.shoulder_left_abduction);
				this.f.shoulder_left_adduction.setValue(this.fctDetails.shoulder_left_adduction);
				this.f.shoulder_right_abduction.setValue(this.fctDetails.shoulder_right_abduction);
				this.f.shoulder_right_adduction.setValue(this.fctDetails.shoulder_right_adduction);
				this.f.elbow_left_flexion.setValue(this.fctDetails.elbow_left_flexion);
				this.f.elbow_left_extension.setValue(this.fctDetails.elbow_left_extension);
				this.f.elbow_right_flexion.setValue(this.fctDetails.elbow_right_flexion);
				this.f.elbow_right_extension.setValue(this.fctDetails.elbow_right_extension);
				this.f.knee_left_flexion.setValue(this.fctDetails.knee_left_flexion);
				this.f.knee_right_flexion.setValue(this.fctDetails.knee_right_flexion);
				this.f.ankle_left_inversion.setValue(this.fctDetails.ankle_left_inversion);
				this.f.ankle_left_eversion.setValue(this.fctDetails.ankle_left_eversion);
				this.f.ankle_right_inversion.setValue(this.fctDetails.ankle_right_inversion);
				this.f.ankle_right_eversion.setValue(this.fctDetails.ankle_right_eversion);
				this.f.ankle_left_plantar.setValue(this.fctDetails.ankle_left_plantar);
				this.f.ankle_left_dorsal.setValue(this.fctDetails.ankle_left_dorsal);
				this.f.ankle_right_plantar.setValue(this.fctDetails.ankle_right_plantar);
				this.f.ankle_right_dorsal.setValue(this.fctDetails.ankle_right_dorsal);
				this.f.wrist_left_flexion.setValue(this.fctDetails.wrist_left_flexion);
				this.f.wrist_right_flexion.setValue(this.fctDetails.wrist_right_flexion);
				this.f.wrist_left_extension.setValue(this.fctDetails.wrist_left_extension);
				this.f.wrist_right_extension.setValue(this.fctDetails.wrist_right_extension);
				this.f.wrist_left_radial_extension.setValue(this.fctDetails.wrist_left_radial_extension);
				this.f.wrist_right_radial_extension.setValue(this.fctDetails.wrist_right_radial_extension);
				this.f.wrist_left_ulnar_extension.setValue(this.fctDetails.wrist_left_ulnar_extension);
				this.f.wrist_right_ulnar_extension.setValue(this.fctDetails.wrist_right_ulnar_extension);
				this.f.wrist_left_pronation.setValue(this.fctDetails.wrist_left_pronation);
				this.f.wrist_right_pronation.setValue(this.fctDetails.wrist_right_pronation);
				this.f.wrist_left_supination.setValue(this.fctDetails.wrist_left_supination);
				this.f.wrist_right_supination.setValue(this.fctDetails.wrist_right_supination);
				this.f.thumb_mcp_flexion.setValue(this.fctDetails.thumb_mcp_flexion);
				this.f.index_mcp_flexion.setValue(this.fctDetails.index_mcp_flexion);
				this.f.middle_mcp_flexion.setValue(this.fctDetails.middle_mcp_flexion);
				this.f.ring_mcp_flexion.setValue(this.fctDetails.ring_mcp_flexion);
				this.f.little_mcp_flexion.setValue(this.fctDetails.little_mcp_flexion);
				this.f.thumb_pip_flexion.setValue(this.fctDetails.thumb_pip_flexion);
				this.f.index_pip_flexion.setValue(this.fctDetails.index_pip_flexion);
				this.f.middle_pip_flexion.setValue(this.fctDetails.middle_pip_flexion);
				this.f.ring_pip_flexion.setValue(this.fctDetails.ring_pip_flexion);
				this.f.little_pip_flexion.setValue(this.fctDetails.little_pip_flexion);
				this.f.thumb_dip_flexion.setValue(this.fctDetails.thumb_dip_flexion);
				this.f.index_dip_flexion.setValue(this.fctDetails.index_dip_flexion);
				this.f.middle_dip_flexion.setValue(this.fctDetails.middle_dip_flexion);
				this.f.ring_dip_flexion.setValue(this.fctDetails.ring_dip_flexion);
				this.f.little_dip_flexion.setValue(this.fctDetails.little_dip_flexion);
				this.f.thumb_abduction.setValue(this.fctDetails.thumb_abduction);
				this.f.index_abduction.setValue(this.fctDetails.index_abduction);
				this.f.middle_abduction.setValue(this.fctDetails.middle_abduction);
				this.f.ring_abduction.setValue(this.fctDetails.ring_abduction);
				this.f.little_abduction.setValue(this.fctDetails.little_abduction);
				this.f.thumb_opposition.setValue(this.fctDetails.thumb_opposition);
				this.f.index_opposition.setValue(this.fctDetails.index_opposition);
				this.f.middle_opposition.setValue(this.fctDetails.middle_opposition);
				this.f.ring_opposition.setValue(this.fctDetails.ring_opposition);
				this.f.little_opposition.setValue(this.fctDetails.little_opposition);
				this.f.mouth_opening.setValue(this.fctDetails.mouth_opening);
				this.f.mouth_opening_unit.setValue(this.fctDetails.mouth_opening_unit);
				this.getDoctorDetails();
				this.selectSavedPoints();
			}, error: (error) => {
				this.loadingFCTDetails = false;
			}
		});
	}

	human_anatomy_points = human_anatomy_points;
	human_anatomy_paths = human_anatomy_paths;
	selectedPoints: any[] = [];
	colors = {
		"upOutline": "#64748B",
		"upColor": "#94A3B8",
		"selectedColor": "#DC3545",
		"selectedOutline": "#CBD5E1"
	}
	humanAnatomyConst = {
		size: 9,
		url: "https=>//www.humananatomyillustrations.com/"
	}

	bindSelectedPoints() {
		this.selectedPoints = [
			...this.human_anatomy_points.MF,
			...this.human_anatomy_points.MB
		].filter(pin => pin.selected);
	}

	removePoint(pin: any) {
		pin.selected = false;
		this.bindSelectedPoints();
	}

	clearAllPoints() {
		this.human_anatomy_points.MF?.forEach(pin => pin.selected = false);
		this.human_anatomy_points.MB?.forEach(pin => pin.selected = false);
		this.bindSelectedPoints();
	}

	selectSavedPoints() {
		const savedSet = new Set(this.fctDetails?.body_parts || []);
		this.human_anatomy_points.MF?.forEach(pin => pin.selected = savedSet.has(pin.seq));
		this.human_anatomy_points.MB?.forEach(pin => pin.selected = savedSet.has(pin.seq));
		this.bindSelectedPoints();
	}

	togglePin(pin: any) {
		pin.selected = !pin.selected;
		this.bindSelectedPoints();
	}

	getSelectedPoints() {
		return [...this.human_anatomy_points.MF, ...this.human_anatomy_points.MB].filter(pin => pin.selected).map(pin => pin.seq);
	}

	selectedDoctorDetails: any = null;
	getDoctorDetails() {
		if (this.f.examining_doctor_id.value) {
			this.apiService.getDoctor({ id: btoa(this.f.examining_doctor_id.value) }).subscribe({
				next: (data: any) => {
					this.selectedDoctorDetails = data.data;
				}, error: (error) => {
					if (error.status == 401) { return }
				}
			});
		} else {
			this.selectedDoctorDetails = null;
		}
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customError = {};
	}

	isSubmitting = false;
	onSubmit() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			Object.keys(this.f).forEach(key => {
				if (this.f[key].errors) {
					let selector = "#" + key;
					try {
						$('html, body').animate({
							scrollTop: $(selector).offset().top - 60 + 'px'
						}, 'fast');
					} catch (error) { }
					$(selector).focus();
					return;
				}
			});
			return;
		}
		const payload: any = {};
		for (const [key, value] of Object.entries(this.moduleForm.value)) {
			payload[key] = value;
		}
		payload["follow_up_id"] = this.followUpDetails.id;
		payload["id"] = this.fctId;
		payload["body_parts"] = this.getSelectedPoints();
		payload.fitness_date = this.apiService.getDateStringFromDate(this.f.fitness_date.value) || null;
		payload.fitness_valid_date = this.apiService.getDateStringFromDate(this.f.fitness_valid_date.value) || null;
		this.isSubmitting = true;
		this.apiService.saveFCT(payload).subscribe({
			next: (res) => {
				this.isSubmitting = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.getFCTDetails();
				this.getReportPdf();
			}, error: (err) => {
				this.isSubmitting = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	isLoadingReport = false;
	fileURL: SafeResourceUrl | null = null;
	private rawObjectUrl: string | null = null; // Keeps track of object URL for cleanup
	blob!: Blob;
	getReportPdf(): void {
		this.isLoadingReport = true;
		this.apiService.getFCTReport(atob(this.followId)).subscribe({
			next: (blob: Blob) => {
				this.blob = blob;
				this.isLoadingReport = false;
				/* Clean up previous Object URL from memory if it exists */
				this.revokeExistingUrl();
				/* Create new Object URL and sanitize it */
				this.rawObjectUrl = URL.createObjectURL(blob);
				this.fileURL = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.rawObjectUrl}#toolbar=0`);
			}, error: (err) => {
				this.isLoadingReport = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	downloadReportPDF() {
		let file_name = this.caseDetails?.f_name + " " + this.caseDetails?.l_name + ".pdf";
		FileSaver.saveAs(this.blob, file_name);
	}

	private revokeExistingUrl(): void {
		if (this.rawObjectUrl) {
			URL.revokeObjectURL(this.rawObjectUrl);
			this.rawObjectUrl = null;
		}
	}

	photo_or_sign: "photo" | "sign" = "photo";
	showWebcam = false;
	isCameraExist = true;
	errors: WebcamInitError[] = [];
	private trigger: Subject<void> = new Subject<void>();
	private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
	imageUploadLoader = false;
	deleteImageLoader: any = null;
	File_Storage_URL = environment.File_Storage_URL;
	openImageModal(type: "photo" | "sign") {
		this.photo_or_sign = type;
		$("#image_signature_modal").modal("show");
		setTimeout(() => {
			if (this.photo_or_sign == "photo") {
				this.openCaptureImage();
			} else {
				this.signaturePad = new SignaturePad(this.canvasRef.nativeElement, {
					backgroundColor: 'rgb(255, 255, 255)',
					penColor: '#0F1773'
				});
			}
		}, 500);
	}

	closeImageModal() {
		this.showWebcam = false;
		$("#image_signature_modal").modal("hide");
	}

	openCaptureImage() {
		WebcamUtil.getAvailableVideoInputs().then((mediaDevices: MediaDeviceInfo[]) => {
			this.isCameraExist = mediaDevices && mediaDevices.length > 0;
			this.showWebcam = true;
		});
	}

	takeSnapshot(): void {
		this.trigger.next();
	}

	handleInitError(error: WebcamInitError) {
		this.errors.push(error);
	}

	changeWebCame(directionOrDeviceId: boolean | string) {
		this.nextWebcam.next(directionOrDeviceId);
	}

	handleImage(webcamImage: WebcamImage) {
		this.urltoFile(webcamImage.imageAsDataUrl, 'image.jpeg', 'image/jpeg').then((file) => {
			this.uploadImage(file);
		});
	}

	get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	get nextWebcamObservable(): Observable<boolean | string> {
		return this.nextWebcam.asObservable();
	}

	urltoFile(url: string, filename: string, mimeType: string) {
		return (fetch(url).then((res) => { return res.arrayBuffer() }).then((buf) => { return new File([buf], filename, { type: mimeType }) }));
	}

	showDropBoxLflag() {
		this.showWebcam = !this.showWebcam;
	}

	allowedImageFiles = allowedLogoFiles;
	photo_folder = "fct_images";
	imageUploaded(path: any) {
		if (this.photo_or_sign == "photo") {
			this.f.candidate_photo.setValue(path);
		} else {
			this.f.candidate_signature.setValue(path);
		}
		this.closeImageModal();
		this.formChanged();
	}

	uploadImage(image: File) {
		this.imageUploadLoader = true;
		const formData = new FormData();
		formData.append('file', image);
		formData.append("type", this.photo_folder);
		formData.append("flag", "true");
		this.imageUploadLoader = true;
		this.apiService.uploadFile(formData).subscribe({
			next: (data: any) => {
				this.imageUploadLoader = false;
				if (this.photo_or_sign == "photo") {
					this.f.candidate_photo.setValue(data);
				} else {
					this.f.candidate_signature.setValue(data);
				}
				this.closeImageModal();
				this.formChanged();
				this.imageUploadLoader = false;
			}, error: (error: any) => {
				this.imageUploadLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	@ViewChild('signatureCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
	private signaturePad!: SignaturePad;

	clearSignature(): void {
		this.signaturePad.clear();
	}

	saveSignature(): void {
		if (this.signaturePad.isEmpty()) {
			this.toastr.warning("Please provide a signature first.", 'Required', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		const base64Image = this.signaturePad.toDataURL('image/png');
		this.urltoFile(base64Image, 'image.png', 'image/png').then((file) => {
			this.uploadImage(file);
		});
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	getTabClass(num: any) {
		if (this.activeTab == num) {
			return "active";
		} else {
			return "";
		}
	}

	getTabPaneClass(num: any) {
		if (this.activeTab == num) {
			return "active";
		} else {
			return "";
		}
	}

	setActiveTab(num: any) {
		this.activeTab = num;
		if (num == 0) {
		} else if (num == 1) {
		} else if (num == 2) {
		}
	}
}
